import React from 'react';
import Hero from '../components/sections/Hero';
import About from '../components/sections/About';
import Experience from '../components/sections/Experience';
import Projects from '../components/sections/Projects';
import Certificates from '../components/sections/Certificates';
import Skills from '../components/sections/Skills';
import Contact from '../components/sections/Contact';
import Footer from '../components/layout/Footer';

const Home = () => {
  return (
    <main>
      <Hero />
      <About />
      <Experience />
      <Projects />
      <Certificates />
      <Skills />
      <Contact />
      <Footer />
    </main>
  );
};

export default Home;